<div class="{{theme}}-theme audio-parent" *ngIf="overview">
    <div class="position-relative border-bottom border-top" *ngIf="overview">

        <img src="{{overview.featureImageUrl}}" class="d-none d-lg-block img-right featured-img" />

        <div class="overview">
            <div class="container-fluid py-4">

                <div class="row">
                    <div class="offset-2 col-10">
                        <h1 class="py-4" [innerHTML]="overview.title"></h1>
                    </div>
                </div>
                <audio-transcript [source]="overview.audioUrl" [transcript]="overview.transcript"></audio-transcript>
                <div class="pt-4 d-lg-none ">
                    <img src="{{overview.featureImageUrl}}" class="featured-img" />
                </div>
                <div *ngFor="let content of overview.contents" class="section-content">
                    <ng-container *ngIf="content.discriminator == 'QuoteText'">
                        <div class="row mb-3 pt-lg-4 quote-container">
                            <div class="offset-2 col-10 offset-md-4 col-md-8 offset-lg-5 col-lg-7 quote py-3 px-3">
                                <div class="emogi my-4 mx-3"></div>
                                <div class="px-3" [innerHTML]="content.text"></div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="content.discriminator == 'HtmlText'">
                        <div class="row py-3">
                            <div class="offset-2 col-10" [innerHTML]="content.text"></div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="content.discriminator == 'Image'">
                        <div class="row py-3">
                            <div class="col-12 offset-md-2 col-md-10">
                                <img src="{{content.imageUrl}}" class="w-100 img-fluid" />
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>